import { themeBackgroundMap } from '@mntn-dev/ui-theme'
import { themeBackgroundBlurMap } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { BladeCommon, type BladeCommonProps } from '../blade-common.tsx'

type BannerBladeProps = PropsWithChildren<BladeCommonProps>

export const BannerBlade = ({
  children,
  className,
  ...props
}: BannerBladeProps) => {
  return (
    <BladeCommon
      className={cn(
        'h-[17.5rem] rounded-lg',
        themeBackgroundMap['container-secondary'],
        `before:${themeBackgroundBlurMap['blur-md-shadow']}`,
        className
      )}
      {...props}
    >
      {children}
    </BladeCommon>
  )
}
